<template>
    <div class="px-1">
      <span class="font-weight-bold">Remarks: </span>
      <b-form-textarea
        @input="addRemarks"
        v-model="post.remarks"
      />
    </div>
</template>

<script>
import { BFormTextarea } from 'bootstrap-vue';
import { computed } from '@vue/composition-api';
import usePostUtils from '@/modules/post/composables/usePostUtils';
import store from '@/store';

export default {
  setup() {
    const { storePost } = usePostUtils();

    const post = computed(() => store.getters['post/post']);

    const addRemarks = () => {
      storePost(post.value);
    };

    return {
      // Reactive
      post,

      // Method
      addRemarks,
    };
  },
  components: { BFormTextarea },
};
</script>
